import { getBatchErrorsByBatchId } from '../autoCheckApi'
import { BatchErrors, BatchType } from '../types'

interface BatchValidationError {
  label: string
  value?: number
}
export interface BatchValidationErrors {
  other?: number
  totalValidClaimsForImport: number
  totalInvalidForImport: number
  totalInvalidForAutoCheck: number
  unSupportedPhoneNumbers: BatchValidationError
  missingRequiredFields: BatchValidationError
  identicalUniqueIds: BatchValidationError
  invalidDataFormat: BatchValidationError
  invalidOrImpreciseValues: BatchValidationError
  invalidFormatting: BatchValidationError
  valueOutOfBounds: BatchValidationError
  valueExceedsLimit: BatchValidationError
  validforAutoCheck?: number
  validforAutoCheckEOB?: number
  validforImport?: number
}
interface BatchValidationErrorsAPI {
  validationErrorDetail: ValidationErrorDetails
  validationStatusDetail: ValidationStatusDetails
}

interface ValidationErrorDetails {
  Other?: number
  'Unsupported or missing phone number(s)'?: number
  'Data validation failure(s); Missing required field(s)'?: number
  'Identical unique ID(s)'?: number
  'Data validation failure(s); Invalid data format(s)'?: number
  'Imprecise value(s)'?: number
  'Invalid format(s)'?: number
  'Data validation failure(s); Value(s) exceeds limits'?: number
  'Value(s) out of bounds'?: number
}
interface ValidationStatusDetails {
  NOT_CHECKED?: number
  VALIDATION_FAILED?: number
  VALID_FOR_IMPORT?: number
  VALID_FOR_AUTOCHECK?: number
  VALID_FOR_AUTOCHECK_EOB?: number
  VALID_FOR_AUTOCHECK_ASC?: number
}

const batchValidationError = {
  label: '',
  value: undefined,
}
const batchValidationErrors: BatchValidationErrors = {
  other: 0,
  totalValidClaimsForImport: 0,
  totalInvalidForImport: 0,
  totalInvalidForAutoCheck: 0,
  unSupportedPhoneNumbers: batchValidationError,
  missingRequiredFields: batchValidationError,
  identicalUniqueIds: batchValidationError,
  invalidDataFormat: batchValidationError,
  invalidOrImpreciseValues: batchValidationError,
  invalidFormatting: batchValidationError,
  valueExceedsLimit: batchValidationError,
  valueOutOfBounds: batchValidationError,
}

export const getBatchErrors = async (batchId: string, batchType: BatchType) => {
  let errorList = batchValidationErrors
  const data = await getBatchErrorsByBatchId(batchId)
  errorList = mapValidationErrors(data.data, batchType)
  return errorList
}

function getBatchErrorLabel(value: string) {
  const res = value.split(';')
  return res[1]
}
function mapValidationErrors(data: BatchValidationErrorsAPI, batchType?: BatchType): BatchValidationErrors {
  const { validationErrorDetail, validationStatusDetail } = data

  if (batchType === BatchType.Claim_Validate) {
    // This is placeholder validation
  }

  const validationErrors: BatchValidationErrors = {
    totalValidClaimsForImport: calculateValidValidatedImport(validationStatusDetail),
    totalInvalidForImport: calculateInValidValidatedImport(validationStatusDetail),
    totalInvalidForAutoCheck: calculateInValidValidatedAutoCheck(validationStatusDetail),
    unSupportedPhoneNumbers: {
      label: BatchErrors.unSupportedPhoneNumbers,
      value: validationErrorDetail[BatchErrors.unSupportedPhoneNumbers],
    },
    missingRequiredFields: {
      label: getBatchErrorLabel(BatchErrors.missingRequiredFields),
      value: validationErrorDetail[BatchErrors.missingRequiredFields],
    },
    identicalUniqueIds: {
      label: BatchErrors.identicalUniqueIds,
      value: validationErrorDetail[BatchErrors.identicalUniqueIds],
    },
    invalidDataFormat: {
      label: getBatchErrorLabel(BatchErrors.invalidDataFormat),
      value: validationErrorDetail[BatchErrors.invalidDataFormat],
    },
    invalidOrImpreciseValues: {
      label: BatchErrors.invalidOrImpreciseValues,
      value: validationErrorDetail[BatchErrors.invalidOrImpreciseValues],
    },
    invalidFormatting: {
      label: BatchErrors.invalidFormatting,
      value: validationErrorDetail[BatchErrors.invalidFormatting],
    },
    valueExceedsLimit: {
      label: getBatchErrorLabel(BatchErrors.valueExceedsLimit),
      value: validationErrorDetail[BatchErrors.valueExceedsLimit],
    },
    valueOutOfBounds: {
      label: BatchErrors.valueOutOfBounds,
      value: validationErrorDetail[BatchErrors.valueOutOfBounds],
    },
    other: validationErrorDetail[BatchErrors.other],
    validforAutoCheck: calculateValidValidatedAutoCheck(validationStatusDetail),
    validforAutoCheckEOB: validationStatusDetail?.VALID_FOR_AUTOCHECK_EOB || 0,
    validforImport: validationStatusDetail?.VALID_FOR_IMPORT || 0,
  }

  Object.keys(validationErrors).forEach(
    (key) =>
      validationErrors[key as keyof BatchValidationErrors] === undefined &&
      delete validationErrors[key as keyof BatchValidationErrors],
  )

  return validationErrors
}

function calculateValidValidatedAutoCheck(data: ValidationStatusDetails) {
  let count = 0
  if (data?.VALID_FOR_AUTOCHECK) {
    count = data.VALID_FOR_AUTOCHECK
  }
  if (data?.VALID_FOR_AUTOCHECK_EOB) {
    count += data.VALID_FOR_AUTOCHECK_EOB
  }
  if (data?.VALID_FOR_AUTOCHECK_ASC) {
    count += data.VALID_FOR_AUTOCHECK_ASC
  }

  return count
}

function calculateValidValidatedImport(data: ValidationStatusDetails) {
  let count = 0
  if (data?.VALID_FOR_AUTOCHECK) {
    count = data.VALID_FOR_AUTOCHECK
  }
  if (data?.VALID_FOR_AUTOCHECK_EOB) {
    count += data.VALID_FOR_AUTOCHECK_EOB
  }
  if (data?.VALID_FOR_IMPORT) {
    count += data.VALID_FOR_IMPORT
  }
  if (data?.VALID_FOR_AUTOCHECK_ASC) {
    count += data.VALID_FOR_AUTOCHECK_ASC
  }

  return count
}

function calculateInValidValidatedAutoCheck(data: ValidationStatusDetails) {
  let count = 0
  if (data?.VALIDATION_FAILED) {
    count = data.VALIDATION_FAILED
  }
  if (data?.VALID_FOR_IMPORT) {
    count += data.VALID_FOR_IMPORT
  }

  return count
}

function calculateInValidValidatedImport(data: ValidationStatusDetails) {
  let count = 0
  if (data?.VALIDATION_FAILED) {
    count = data.VALIDATION_FAILED
  }
  return count
}
